import React, { createContext, useContext, useState, useEffect } from 'react';

const ProposalContext = createContext(null);

export const ProposalProvider = ({ children }) => {
  const [selectedProducts, setSelectedProducts] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem('proposal_products');
    if (saved) {
      try {
        setSelectedProducts(JSON.parse(saved));
      } catch (e) {
        console.error('Failed to parse saved proposal:', e);
      }
    }
  }, []);

  const addToProposal = (product) => {
    const exists = selectedProducts.find(p => p.id === product.id);
    if (!exists) {
      const updated = [...selectedProducts, product];
      setSelectedProducts(updated);
      localStorage.setItem('proposal_products', JSON.stringify(updated));
      return true;
    }
    return false;
  };

  const removeFromProposal = (productId) => {
    const updated = selectedProducts.filter(p => p.id !== productId);
    setSelectedProducts(updated);
    localStorage.setItem('proposal_products', JSON.stringify(updated));
  };

  const clearProposal = () => {
    setSelectedProducts([]);
    localStorage.removeItem('proposal_products');
  };

  const isInProposal = (productId) => {
    return selectedProducts.some(p => p.id === productId);
  };

  return (
    <ProposalContext.Provider value={{ 
      selectedProducts, 
      addToProposal, 
      removeFromProposal, 
      clearProposal,
      isInProposal 
    }}>
      {children}
    </ProposalContext.Provider>
  );
};

export const useProposal = () => {
  const context = useContext(ProposalContext);
  if (!context) {
    throw new Error('useProposal must be used within a ProposalProvider');
  }
  return context;
};
